import { Fragment, type ReactNode } from 'react';

/**
 * Puts elements (a bold word, a link, a button) into a translated sentence at
 * its {holes}, so each language can put them where its own word order needs
 * them (D146). `fillParts(t('…'), { share: <strong>Share</strong> })`
 */
export function fillParts(
  text: string,
  parts: Record<string, ReactNode>
): ReactNode[] {
  return text
    .split(/\{(\w+)\}/g)
    .map((piece, index) => (
      <Fragment key={index}>
        {index % 2 === 1
          ? piece in parts
            ? parts[piece]
            : `{${piece}}`
          : piece}
      </Fragment>
    ));
}
